// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"d36f3f5f33f12c5b","6831":"9783977d926b7bd5","8503":"e00ca06c83fc9b49","9683":"7c608479eff44cce"}[chunkId] + ".js";
};